import styled, { css } from 'styled-components'

export const VendorLogoBadgeLayoutStyled = styled.div<{ $outlined: boolean }>`
  display: flex;
  align-items: center;
  width: fit-content;
  flex-shrink: 0;
  overflow: hidden;

  ${(props) =>
    props.$outlined &&
    css`
      padding: ${`${props.theme.typography.pxToRem(1)} ${props.theme.space.small}`};
      border: ${props.theme.typography.pxToRem(1)} solid
        ${props.theme.colors.badge.neutral.border};
      border-radius: ${props.theme.typography.pxToRem(4)};
      background: ${props.theme.colors.white};
    `}
`
